import type { AreaCatalog } from '../area';
import type { fields as en } from '../en/fields';

export const fields = {
  'fields.description.label': 'Beschreibung',
  'fields.description.placeholder': 'Beschreibung hinzufügen…',
  'fields.description.edit': 'Beschreibung bearbeiten',
  'fields.note.label': 'Notiz',
  'fields.note.placeholder': 'Notiz hinzufügen…',
  'fields.note.edit': 'Notiz bearbeiten',

  'fields.markdown.taskChecked': 'Angehakt',
  'fields.markdown.taskOpen': 'Nicht angehakt',

  'fields.entitySet.search': 'Personen suchen…',
  'fields.entitySet.empty': 'Niemand zum Hinzufügen.',
  'fields.entitySet.remove': '{name} entfernen',

  'fields.tags.tag': 'Tag',
  'fields.tags.add': 'Tag hinzufügen',
  'fields.tags.edit': '#{tag} bearbeiten',
  'fields.tags.path': 'Tag-Pfad',
  'fields.tags.remove': 'Entfernen',
  'fields.tags.removeTag': '#{tag} entfernen',

  'fields.time.grain.day': 'Tag',
  'fields.time.grain.week': 'Woche',
  'fields.time.grain.month': 'Monat',
  'fields.time.grain.quarter': 'Quartal',
  'fields.time.grain.year': 'Jahr',
  'fields.time.grain.other': 'Andere',
  'fields.time.precision': '{label}: Genauigkeit',
  'fields.time.year': '{label}: Jahr',
  'fields.time.quarter': '{label}: Quartal',
  'fields.time.quarterNone': 'Q…',
  'fields.time.quarterOption': 'Q{n}',
  'fields.time.weekExample': '2026-W24',
  'fields.time.rangeExample': '2026-Q1/2026-Q3',
  'fields.time.otherHint':
    'Jede kanonische Zeit: ein Zeitpunkt oder ein Zeitraum von Anfang bis Ende wie 2026-Q1/2026-Q3',

  'fields.pushRule.myGroups': 'Meine Gruppen',
  'fields.pushRule.onlyThese': 'Nur diese',
  'fields.pushRule.askMe': 'Mich fragen',
  'fields.pushRule.members': 'Mitglieder',
  'fields.pushRule.ask': 'Fragen',
  'fields.pushRule.label': 'Wer direkt einsetzen darf',
  'fields.pushRule.remove': '{name} aus dem Kreis entfernen',
  'fields.pushRule.add': 'Zum Kreis hinzufügen…',
  'fields.pushRule.empty': 'Niemand zum Hinzufügen.',

  'fields.factRules.mode.declare': 'nennen',
  'fields.factRules.mode.propose': 'vorschlagen',
  'fields.factRules.always': 'immer',
  'fields.factRules.while': 'solange {attr}: {value}',
  'fields.factRules.needsDays':
    'Wie lange darf „{fact}“ dauern, bevor es zählt? Das weiß hier niemand.',
  'fields.factRules.needsWord': 'Eine Stufe braucht ein Wort: Wie nennt dieser Ablauf es?',
  'fields.factRules.needsTag': 'Welcher Tag? Wähle den Tag, den diese Regel nennt.',
  'fields.factRules.needsStage': 'Welche Phase? Wähle eine Phase dieses Ablaufs.',
  'fields.factRules.stage': 'Phase',
  'fields.factRules.pickStage': 'Phase wählen',
  'fields.factRules.equals': '=',
  'fields.factRules.fact': 'Fakt',
  'fields.factRules.past': 'über',
  'fields.factRules.days': 'Tage',
  'fields.factRules.daysEquals': 'Tage =',
  'fields.factRules.grade': 'Stufe',
  'fields.factRules.grade.notice': 'Hinweis',
  'fields.factRules.grade.warning': 'Warnung',
  'fields.factRules.grade.critical': 'kritisch',
  'fields.factRules.firing': 'Was beim Auslösen passiert',
  'fields.factRules.word': 'Wort',
  'fields.factRules.wordPlaceholder': 'Stockt',
  'fields.factRules.whileCondition': 'Gilt solange',
  'fields.factRules.remove': 'Regel {fact} = {grade} entfernen',
  'fields.factRules.add': '+ Regel hinzufügen',

  'fields.defs.type.text': 'Text',
  'fields.defs.type.prose': 'Langer Text (Markdown)',
  'fields.defs.type.number': 'Zahl',
  'fields.defs.type.date': 'Datum',
  'fields.defs.type.selection': 'Auswahl',
  'fields.defs.type.actor': 'Person oder Gruppe',
  'fields.defs.typeWord.text': 'Text',
  'fields.defs.typeWord.prose': 'Langer Text',
  'fields.defs.typeWord.number': 'Zahl',
  'fields.defs.typeWord.date': 'Datum',
  'fields.defs.typeWord.selection': 'Auswahl',
  'fields.defs.typeWord.actor': 'Person oder Gruppe',
  'fields.defs.typeWordMany': '{type} · mehrere',
  'fields.defs.problem.name': 'Gib dem Feld einen Namen.',
  'fields.defs.problem.description': 'Sag, was dieses Feld bedeutet.',
  'fields.defs.problem.values': 'Eine Auswahl braucht mindestens einen Wert.',
  'fields.defs.about': 'Über Felder',
  'fields.defs.aboutText':
    'Ein Feld braucht eine Beschreibung: Sag, was es bedeutet, nicht nur, was es speichert. Dieselben Worte beschreiben es allen, die es später lesen, Menschen wie Agenten.',
  'fields.defs.minted': 'wird beim Speichern vergeben',
  'fields.defs.remove': 'Feld {name} entfernen',
  'fields.defs.edit': 'Feld {name} bearbeiten',
  'fields.defs.inUseConfirm': 'In Verwendung: {refs}. Trotzdem entfernen?',
  'fields.defs.inUse': 'In Verwendung: {refs}',
  'fields.defs.removeConfirm': 'Entfernen',
  'fields.defs.keep': 'Behalten',
  'fields.defs.untitled': 'Ohne Titel',
  'fields.defs.onCards': 'auf Karten',
  'fields.defs.name': 'Name',
  'fields.defs.namePlaceholder': 'z. B. Priorität',
  'fields.defs.nameLabel': 'Feldname',
  'fields.defs.type': 'Typ',
  'fields.defs.typeLabel': 'Feldtyp',
  'fields.defs.holds': 'Enthält',
  'fields.defs.holdsLabel': 'Wie viele Werte dieses Feld enthält',
  'fields.defs.holdsOne': 'Einen Wert',
  'fields.defs.holdsMany': 'Mehrere',
  'fields.defs.cards': 'Karten',
  'fields.defs.showOnCardsHint':
    'Karten der Aufgaben im Ablauf zeigen den Wert dieses Felds (höchstens drei pro Karte)',
  'fields.defs.showOnCards': 'Auf Karten zeigen',
  'fields.defs.description': 'Beschreibung',
  'fields.defs.descriptionLabel': 'Feldbeschreibung',
  'fields.defs.values': 'Werte',
  'fields.defs.valuesHint':
    'Enter fügt einen Wert hinzu; klick auf einen Wert, um ihn zu beschreiben.',
  'fields.defs.valuesLabel': 'Werte der Auswahl',
  'fields.defs.valuesPlaceholder': 'Wert hinzufügen',
  'fields.defs.discards': {
    one: 'Beim Speichern als {type} geht {count} Wert verloren; wechsle zurück zu Auswahl, um ihn zu behalten.',
    other:
      'Beim Speichern als {type} gehen {count} Werte verloren; wechsle zurück zu Auswahl, um sie zu behalten.',
  },
  'fields.defs.done': 'OK',
  'fields.defs.add': '+ Feld hinzufügen',
} as const satisfies AreaCatalog<typeof en>;
